import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';

import { inventoryVolumeQueryLinkerSchema } from './inventory-volumes-query-linker-schema';

export const inventoryVolumeQuerySchema = z.object({
  ...inventoryVolumeQueryLinkerSchema.shape,
});

export type InventoryVolumeQuerySchema = z.infer<typeof inventoryVolumeQuerySchema>;

export const tcCategoryQueryAllSchema = paginatedResponseSchema(inventoryVolumeQuerySchema);

export type InventoryVolumeQueryAllSchema = z.infer<typeof tcCategoryQueryAllSchema>;
